import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Trigger from '@mtfe/rc-trigger';
import dayjs from 'dayjs';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import locale from '../locale';
import { isFunction } from '@utiljs/is';
import { onOpenChange, mouseEnter, mouseLeave } from './utils';
import TimePicker from './TimePicker';
import { getPlacements } from './placements';
import Icon from '../Icon';
import Input from '../Input';
import '@mtfe/rc-trigger/assets/index.css';

var TimeSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeSelect, _React$Component);

  var _super = _createSuper(TimeSelect);

  function TimeSelect() {
    var _this;

    _classCallCheck(this, TimeSelect);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: _this.props.value || _this.props.defaultValue || '',
      closeShow: false,
      open: _this.props.open
    };
    _this.rootNode = createRef();
    _this.inputNode = createRef();

    _this.onOpenChange = function () {};

    _this.clearTime = function () {
      _this.setState({
        value: ''
      });

      _this.props.onChange('');
    };

    _this.mouseEnter = mouseEnter.bind(_assertThisInitialized(_this));
    _this.mouseLeave = mouseLeave.bind(_assertThisInitialized(_this));

    _this.inputFocus = function () {
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.inputBlur = function () {
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.selectTime = function (time, type) {
      var value = _this.state.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          format = _this$props.format;
      var arr = value.split(':');

      var day = _this.setValue(arr);

      _this.setState({
        value: day.set(type, time).format(format)
      }, function () {
        onChange(day.set(type, time).format(format));
      });
    };

    _this.findFormatIndex = function (formatList, format, defaultIndex) {
      var index = formatList.indexOf(format);
      return index !== -1 ? index : defaultIndex;
    };

    _this.setValue = function (arrTime) {
      var format = _this.props.format;
      var formatArr = format.split(':');
      var formatList = formatArr.map(function (item) {
        return item.toLocaleLowerCase();
      });
      var time = dayjs();

      if (formatList.includes('hh')) {
        time = time.set('hour', _parseInt(arrTime[_this.findFormatIndex(formatList, 'hh', 0)] || time.hour(), 10));
      }

      if (formatList.includes('mm')) {
        time = time.set('minute', _parseInt(arrTime[_this.findFormatIndex(formatList, 'mm', 1)] || time.minute(), 10));
      }

      if (formatList.includes('ss')) {
        time = time.set('second', _parseInt(arrTime[_this.findFormatIndex(formatList, 'ss', 2)] || time.second(), 10));
      }

      return time;
    };

    return _this;
  }

  _createClass(TimeSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onOpenChange = onOpenChange.bind(this);
      window.addEventListener('click', this.onOpenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onOpenChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          value = _this$state.value,
          open = _this$state.open,
          closeShow = _this$state.closeShow;
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          defaultValue = _this$props2.defaultValue,
          popupContainer = _this$props2.popupContainer,
          className = _this$props2.className,
          clearable = _this$props2.clearable,
          disabled = _this$props2.disabled,
          disabledTime = _this$props2.disabledTime,
          format = _this$props2.format,
          inputClassName = _this$props2.inputClassName,
          size = _this$props2.size,
          flip = _this$props2.flip,
          placement = _this$props2.placement;
      var arrTime = value && value.split(':');
      var defaultArrTime = defaultValue && defaultValue.split(':');
      return /*#__PURE__*/React.createElement(Trigger, {
        builtinPlacements: getPlacements(flip),
        popupPlacement: placement,
        popupVisible: disabled ? false : open,
        getPopupContainer: isFunction(popupContainer) ? popupContainer : function () {
          return popupContainer;
        },
        popupStyle: {
          whiteSpace: 'nowrap'
        },
        action: ['click'],
        popup: /*#__PURE__*/React.createElement(TimePicker, {
          timeRef: this.rootNode,
          format: format,
          className: className,
          value: this.setValue(arrTime),
          defaultValue: this.setValue(defaultArrTime),
          onChange: this.selectTime,
          disabledTime: disabledTime
        })
      }, /*#__PURE__*/React.createElement(Input, {
        placeholder: placeholder,
        inputRef: this.inputNode,
        onFocus: this.inputFocus,
        onBlur: this.inputBlur,
        className: inputClassName,
        disabled: disabled,
        size: size,
        suffix: clearable && !disabled ? /*#__PURE__*/React.createElement(Icon, {
          name: closeShow ? 'times-circle' : 'time',
          onClick: this.clearTime,
          onMouseEnter: this.mouseEnter,
          onMouseLeave: this.mouseLeave
        }) : /*#__PURE__*/React.createElement(Icon, {
          name: "time"
        }),
        value: value || ''
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (!nextProps.value) {
        return {};
      }

      if (nextProps.value !== state.value) {
        return {
          value: nextProps.value
        };
      }

      return {};
    }
  }]);

  return TimeSelect;
}(React.Component);

TimeSelect.defaultProps = {
  defaultValue: '',
  value: '',
  placeholder: locale.lng('DatePicker.placeholder'),
  className: '',
  inputClassName: '',
  disabled: false,
  clearable: false,
  format: 'HH:mm:ss',
  flip: false,
  open: false,
  size: 'normal',
  placement: 'bottomLeft',
  popupContainer: document.body || document.documentElement,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  disabledTime: function disabledTime() {
    return false;
  }
};
TimeSelect.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  disabled: PropTypes.bool,
  flip: PropTypes.oneOfType([PropTypes.bool]),
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'bottomLeft', 'bottomRight', 'topLeft', 'topRight']),
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  open: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabledTime: PropTypes.func
};
polyfill(TimeSelect);
export default TimeSelect;